import { render, staticRenderFns } from "./termsGold.vue?vue&type=template&id=c142f0e6&scoped=true"
import script from "./termsGold.vue?vue&type=script&lang=js"
export * from "./termsGold.vue?vue&type=script&lang=js"
import style0 from "./termsGold.vue?vue&type=style&index=0&id=c142f0e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c142f0e6",
  null
  
)

export default component.exports